import { Controller } from "@hotwired/stimulus"

// Bloc repliable : l'en-tête (trigger) ouvre ou referme le contenu (panel).
// S'ouvre aussi quand l'ancre de l'élément est visée (lien « #poser-question »).
export default class extends Controller {
  static targets = ["trigger", "panel"]
  // restQuery : media query pour laquelle le bloc est replié au repos (ex. « (min-width: 1024px) »).
  static values = { open: { type: Boolean, default: true }, restQuery: String }

  connect() {
    if (this.restQueryValue) {
      // Sous le point de rupture : bloc toujours ouvert et sans bascule. Au-dessus : repliable.
      this.media = window.matchMedia(this.restQueryValue)
      this.onMedia = () => this.applyMedia()
      this.media.addEventListener("change", this.onMedia)
      if (this.targeted) this.openValue = true
      else if (this.media.matches) this.openValue = false
      this.applyMedia()
    } else if (this.targeted) {
      this.openValue = true
    }
    this.render()
  }

  disconnect() { this.media?.removeEventListener("change", this.onMedia) }

  get collapsible() { return !this.media || this.media.matches }

  applyMedia() {
    if (!this.collapsible) this.openValue = true
    const t = this.triggerTarget
    if (this.collapsible) {
      t.setAttribute("role", "button")
      t.setAttribute("tabindex", "0")
      t.setAttribute("aria-controls", this.panelTarget.id)
    } else {
      ;["role", "tabindex", "aria-controls", "aria-expanded"].forEach((a) => t.removeAttribute(a))
    }
    this.render()
  }

  key(event) {
    if (this.collapsible && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); this.toggle() }
  }

  open() { this.openValue = true }

  toggle() { if (this.collapsible) this.openValue = !this.openValue }

  reveal() { if (this.targeted) this.openValue = true }

  // Clic sur un lien vers l'ancre alors que l'URL la porte déjà : pas de hashchange, on déplie quand même.
  revealOnLink(event) {
    if (event.target.closest?.(`a[href="#${this.element.id}"]`)) this.openValue = true
  }

  openValueChanged() { this.render() }

  get targeted() { return this.element.id && window.location.hash === `#${this.element.id}` }

  render() {
    this.panelTargets.forEach((panel) => {
      panel.hidden = !this.openValue
      panel.dataset.ready = "" // CSS : à partir de là, la transition d'ouverture est active
    })
    if (this.collapsible) this.triggerTarget.setAttribute("aria-expanded", String(this.openValue))
  }
}
